export const AgreementStringHeader = () => <h1 className='agreementStringHeader'>I Hereby Certify the Following:</h1>;
export const ManualAgreementStringBody = () => (
    <div>
        <ol>
            <li style={{ paddingBottom: 25 }}>I have personally reviewed this draw submission and agree to draw funds.</li>
            <li style={{ paddingBottom: 25 }}>
                To the extent to which I am requesting funds for a line item, I am stating that work to be complete at the subject
                property unless otherwise specifically noted.
            </li>
            <li style={{ paddingBottom: 25 }}>
                All work stated to be complete herein is, in fact, complete and has been performed in acceptable standards of
                workmanship and quality.
            </li>
            <li style={{ paddingBottom: 25 }}>
                All work has been completed in accordance with the approved plans and specs of the project.
            </li>
            <li style={{ paddingBottom: 25 }}>
                All invoices and contracts covered by previous draws requests have been paid in full and no delinquent invoices
                exist.
            </li>
            <li>
                No unsatisfied mechanic's, workman's, or other similar liens have been placed on the property, and none are
                reasonably expected.
            </li>
        </ol>
    </div>
);
export const AutomaticAgreementStringBody = () => (
    <div>
        <ol>
            <li style={{ paddingBottom: 25 }}>I agree to draw funds.</li>
            <li style={{ paddingBottom: 25 }}>
                By selecting an Automatic draw I understand and agree that I may receive a different amount of funding than I
                expect.
            </li>
            <li style={{ paddingBottom: 25 }}>
                The amount of the draw will be based on work considered complete according to an inspection ordered by the Lender
                and potentially adjusted at Lender's sole and absolute discretion according to a request that I have made and/or
                any other consideration determined to be relevant by Lender. All work has been performed in acceptable standards
                of workmanship and quality.
            </li>
            <li style={{ paddingBottom: 25 }}>
                All work has been completed in accordance with the approved plans and specs of the project.
            </li>
            <li style={{ paddingBottom: 25 }}>
                All invoices and contracts covered by previous draws requests have been paid in full and no delinquent invoices
                exist.
            </li>
            <li>
                No unsatisfied mechanic's, workman's, or other similar liens have been placed on the property, and none are
                reasonably expected.
            </li>
        </ol>
    </div>
);
